/* eslint-disable react-hooks/exhaustive-deps */
import { colors, Container, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import _ from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import Page from 'src/components/Page';
import { CustomHeader, GridTable, SubHeadButtons } from '.';

const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  button: {
    marginRight: theme.spacing(1),
    height: '52px',
  },
  divider: {
    backgroundColor: colors.grey[300],
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  tableContainer: {
    marginBottom: theme.spacing(7),
  },
}));

function SubjectManagement({
  users,
  headerData,
  headerConfig,
  onHeaderChanges,
  subHeaderConfig,
  onSubHeaderChanges,
  tableData,
  tableConfig,
  onTableRowClick,
  onCheckboxClick,
  onTableHeaderInputClick,
  onRowDelete,
  activeTableRowStatus,
  tableDataChange,
  onDragStart,
  onDragEnd,
}) {
  const classes = useStyles();
  const [searchText, setSearchText] = useState(['']);
  const [tableConfigState, setTableConfigState] = useState([]);

  useEffect(() => {
    setTableConfigState(tableConfig);
    const items = [];
    tableConfig.forEach(() => {
      items.push('');
    });
    setSearchText(items);
  }, [tableConfig, tableConfigState]);

  // ************************************* Table Methods ******************************************
  const handleRowSelection = useCallback(({ event, currentRow, selectedRows }, index) => {
    // eslint-disable-next-line
    if (onCheckboxClick) {
      onCheckboxClick({
        event,
        currentRow,
        selectedRows,
        index,
      });
    }
    // eslint-disable-next-line
  });

  const handleRowDelete = useCallback(rowsSelected => {
    onRowDelete({ rowsSelected });
  });

  const handleCellButtonClick = () => {
    //
  };

  const handleSwitchChange = () => {
    //
  };

  const handleTableSearchChange = (event, value, index, element) => {
    const items = _.cloneDeep(searchText);
    items[element.tableIndex] = value;
    setSearchText(items);
  };

  const handleTableHeadInputClick = (event, inputValue, tableMap) => {
    onTableHeaderInputClick({
      event,
      inputValue,
      tableMap,
    });
  };

  // ************************************************************************************************

  // ************************************* subHead methods ******************************************
  const handleDropdownChange = () => {
    //
  };

  // Will search always the first table.
  const handleSearchChange = (event, value) => {
    setSearchText([value]);
  };

  const handleSearchClick = () => {
    //
  };

  const handleButtonClick = (buttonText, inputEntry, dropDownSelections) => {
    onSubHeaderChanges({
      buttonText,
      inputEntry,
      dropDownSelections,
    });
  };

  const handleInputChange = () => {
    //
  };

  // ************************************************************************************************

  // ************************************* Head methods *********************************************
  const handleHeaderButtonClick = event => {
    if (typeof onHeaderChanges === 'function') {
      onHeaderChanges(event);
    }
  };
  // ************************************************************************************************

  return (
    <Page className={classes.root} title="Subject Management">
      <Container maxWidth={false}>
        {headerConfig && (
          <CustomHeader
            headerConfig={headerConfig}
            headerData={headerData}
            onSearchClick={handleSearchClick}
            onSearchChange={handleSearchChange}
            onButtonClick={handleHeaderButtonClick}
          />
        )}

        {subHeaderConfig && (
          <SubHeadButtons
            selectOptions={users}
            subHeadConfig={subHeaderConfig}
            onDropdownChange={handleDropdownChange}
            onSearchClick={handleSearchClick}
            onSearchChange={handleSearchChange}
            onButtonClick={handleButtonClick}
            onInputChange={handleInputChange}
          />
        )}

        {tableConfigState && tableData && (
          <Grid container spacing={1} alignItems="stretch" className={classes.tableContainer}>
            {tableConfigState.map((config, index) => (
              <Grid item lg={config.lg} xs={config.xs} key={index}>
                <GridTable
                  searchText={searchText[index]}
                  tableConfig={config}
                  subjects={Array.isArray(tableData[index]) ? tableData[index] : tableData}
                  onRowSelection={payload => handleRowSelection(payload, index)}
                  onRowDelete={handleRowDelete}
                  onCellButtonClick={handleCellButtonClick}
                  onSwitchChange={handleSwitchChange}
                  onSearchChange={handleTableSearchChange}
                  onTableHeadInputClick={handleTableHeadInputClick}
                  onTableRowClick={onTableRowClick}
                  activeRowStatus={activeTableRowStatus}
                  onTableDataChange={tableDataChange}
                  onDragStart={onDragStart}
                  onDragEnd={onDragEnd}
                />
              </Grid>
            ))}
          </Grid>
        )}
      </Container>
    </Page>
  );
}

export { SubjectManagement };
